// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { initializeAnalytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";
import { getStorage } from "firebase/storage";
import { getFirebaseConfig } from "./config/clientConfig";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const config = getFirebaseConfig();

// Initialize Firebase
export const app = initializeApp(config);
export const auth = getAuth(app);
// export const analytics = getAnalytics(app);
export const analytics = initializeAnalytics(app, { config: { send_page_view: false } });
export const storage = getStorage(app);

// connectAuthEmulator(auth, "http://localhost:9099")

export const db = getFirestore(app);
// connectFirestoreEmulator(db, "localhost", 8080)

export const performanceMonitoring = getPerformance(app);
